export default __webpack_public_path__ + "static/media/office2-afterA-1920w.ec057224.webp";